import { useState } from 'react';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

const TABS = [
  { key: 'latest', label: '最新发布' },
  { key: 'popular', label: '热门推荐' },
  { key: 'scenery', label: '四季风光' },
  { key: 'stories', label: '青春故事' },
];

export default function LatestArticles() {
  const [activeTab, setActiveTab] = useState('latest');

  const displayArticles = activeTab === 'latest'
    ? [...articles].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 8)
    : activeTab === 'popular'
    ? articles.slice(0, 8)
    : articles.filter(a => a.categorySlug === activeTab).slice(0, 8);

  return (
    <section className="w-full px-6 md:px-10 py-20">
      <div className="text-center mb-12">
        <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">ARTICLES</p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
          最新文章
        </h2>
      </div>

      <div className="flex items-center justify-center mb-10">
        <div className="inline-flex bg-background-100 rounded-full px-1 py-1">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-5 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all duration-300 ${
                activeTab === tab.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {displayArticles.map((article) => (
          <ArticleCard key={article.id} article={article} variant="default" />
        ))}
      </div>
    </section>
  );
}